import React, { Component, Fragment } from "react";
import { withRouter, Link } from "react-router-dom";
import { Col, Row, ProgressBar } from "react-bootstrap";
import ReactTable from "react-table";
import debounce from "lodash/debounce";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import ProjectsService from "../../../services/ProjectsService"; 
import HandleError from "../../../services/HandleError";
import DeleteModal from "../../modals/DeleteModal";
import Materialicon from "../../helpers/Materialicon";
import TasksConfirmationModal from "../../modals/TasksConfirmationModal";
import { minutesToHourAndMinutes } from "../../helpers/HelperFunctions";

class ProjectsPage extends Component {
	state = {
		showConfirmationModal: false,
		projectToDelete: null,
		isDeleting: false,
		isLoadingTable: true,
		message: "",
		data: [],
		pages: 1,
	}

	getProjects= (state) => {
		const {pageSize, sorted, filtered, page } = state;
		const data = JSON.stringify({pageSize, sorted, filtered, page});
		this.setState({ isLoadingTable: true});
		this.projectsService.index(page+1, `data=${data}`).then((res) => {
			this.setState({ isLoadingTable:false, data: res.data.data, pages: res.data.last_page, pageState: state});
		}).catch((err) => {
			this.setState({isLoadingTable:false});
			HandleError(err,this);
		});
	}

	projectToDelete = (project) => {
		this.setState({projectToDelete : {name: project.name, id: project.id}});
	}
	
	deleteProject = () => {
		if(this.state.projectToDelete) {
			this.setState({ isDeleting: true });
			this.projectsService.delete(this.state.projectToDelete.id).then((res) => {
				this.setState({ isDeleting: false });
				NotificationManager.success("Project deleted.", "Success!");
			}).catch((err) => {
				this.setState({ isDeleting: false });
				HandleError(err, this);
			}).then(() => {	
				this.getProjects(this.state.pageState);		
				this.closeModal();
			});
		}
	}

	handleResponse = () => {
		if(this.state.selectedProject && this.state.selectedProject.id) {
			this.setState({actionLoading:true});		
			this.projectsService.changeStatus(this.state.selectedProject.id, {status:"Finished"}).then((res) => {
				this.setState({actionLoading:false, showConfirmationModal: false, selectedProject: null});
				NotificationManager.success("Project finished.","Success!");					 
			}).catch((err) => {
				this.setState({actionLoading:false, showConfirmationModal: false, selectedProject: null});					
				HandleError(err, this);
			}).then(()=> {
				this.getProjects(this.state.pageState);	
			});
		}
	}

	handleConfirmationModal = (project, message, item) => {
		if(project) {
			this.setState({ 
				showConfirmationModal : true,
				selectedProject: project,
				message,
				item
			});
		}
	}

	handleClose = () => { this.setState({ showConfirmationModal: false, selectedProject: null });}


	closeModal = () => {
		this.setState({
			projectToDelete: null,
			isDeleting: false,
		});
	}

    projectsService = new ProjectsService(this);
    render() {
    	const { data, isLoadingTable, pages, showConfirmationModal,actionLoading, message } = this.state;
    	return (
    		<div className="crud-page customers-page">
    			<div className="container-fluid">
    				<section className="actions">
    					<Row>
    						<Col md={6} sm={6} xs={12}>
    							<h2 className="page-title">All Projects</h2>
    						</Col>
    						<Col md={6} sm={6} xs={12}>
    							<Link to="/projects/create-project" className="pull-right btn-add-big btn btn-default">
    								<Materialicon icon="add_circle_outline" /> Add Project
    							</Link>
    						</Col>
    					</Row>   
    				</section>
    				<div className="card card-top-border connection-card fadeInLoadUp">
    					<ReactTable
    						columns={[
    							{
    								Header: "Id",
    								accessor: "id",
    								Cell: row => <div className="text-center">{row.value}</div>,
    								minWidth: 50
    							}, 
    							{
    								Header: "Project Name",
    								accessor: "name",
    								Cell: row => <div className="text-center"><Link to={`/projects/${row.original.id}/info`} className="text-center">{row.value}</Link></div>,
    								minWidth: 200
    							}, {
    								Header: "Client",
    								accessor: "full_company_name",
    								Cell: row => <div className="text-center">{row.value}</div>,
    								minWidth: 200
    							}, {
    								Header: "Type",
    								accessor: "type",
    								Cell: row => (<div className="text-center"> {row.value} </div>),
    							},
    							{
    								Header: "Status",
    								accessor: "status",
    								Cell(row) {
    									switch(row.value) {
    									case "Active":
    										return <div className="text-center"><span className="status status-in-progress">Active</span></div>;
    									case "NotActive":
    										return <div className="text-center"><span className="status status-inactive">Inactive</span></div>;
    									case "StandBy":
    										return <div className="text-center"><span className="status status-to-do">StandBy</span></div>;
    									case "Finished":
    										return <div className="text-center"><span className="status status-done">Finished</span></div>;
    									default:
    										return <div className="text-center"><span className="status status-default">{row.value}</span></div>;
    									}
    								}
    							},
    							{
    								Header: "Progress",
    								accessor: "progress",
    								filterable: true,
    								sortable: true,
    								Cell(cellInfo) {
    									const status = cellInfo.original && cellInfo.original.status;
    									const completed = parseInt(cellInfo.value,0,10);
    									if(status && completed>=0) {
    										let styleClass = "info";
    										if(completed > 100) { styleClass = "danger"; }
    										else if(status==="Finished"){ styleClass = "success"; }
    										return <ProgressBar bsStyle={styleClass}  now={completed>100?100:completed} label={`${completed}%`} />;
    									}               
    									return "No progress!";
    								},	 
    							},
    							{
    								Header: "Total Hours",
    								accessor: "total_hours",
    								filterable: false,
    								sortable: false,
    								Cell: (row) => {
    									const {hours, minutes} = minutesToHourAndMinutes(row.value);
    									return (
    										<div className="text-center"> 
    											{ hours > 0 ? `${hours}h` : `${0}h`} { minutes > 0 ? ` and ${minutes}min` : null}
    										</div>
    									);
    								}
    							},
    							{
    								Header: "Deadline",
    								accessor: "deadline",
    								Cell: row => (<div className="text-center">{moment(row.value).format("DD-MM-YYYY")}</div>),
    								minWidth: 150
    							},
    							{
    								Header: "Date Created",
    								accessor: "created_at",
    								Cell: row => (<div className="text-center">{moment(row.value).format("DD-MM-YYYY")}</div>),
    								minWidth: 150
    							},
    							{
    								Header: "Actions",
    								accessor: "id",
    								filterable: false,
    								sortable: false,
    								Cell: row => {
    									const name = row.original.name || "";
    									const status = row.original.status || null;
    									let disableButton = false;
    									if(status && status === "Finished") { // eslint-disable-line
    										disableButton = true;
    									}
    									return  (
    										<div className="text-center">
    											<button title="Finish project" disabled={disableButton} className="btn-action material-icons btn-accept" onClick={() => this.handleConfirmationModal(row.original, `You are changing "${name}" status to finished!`, "finish")}>done</button>
    											<Link title="Edit" to={`/projects/${row.value}/edit`} className="btn-action material-icons btn-edit">edit</Link>
    											<button  title="Delete" onClick={() => this.projectToDelete(row.original)} className="btn-action material-icons btn-delete">delete</button>
    										</div>
    									);
    								}
    							}
    						]}
    						manual 
    						data={data}
    						pages={pages} 
    						loading={isLoadingTable}
    						onFetchData={ debounce(this.getProjects, 200) } 
    						filterable
    						defaultSorted={[{ id: "created_at", desc: true }]}
    						defaultPageSize={20}
    						className="-highlight"
    					/>
    				</div>   
    			</div>
    			<DeleteModal
    				itemToDelete={this.state.projectToDelete}
    				deleteItem={this.deleteProject}
    				isDeleting={this.state.isDeleting}
    				closeModal={this.closeModal}
    			/>
    			<TasksConfirmationModal
					 isLoading={actionLoading}
					 message={message}
					 showConfirmationModal={showConfirmationModal}
					 handleResponse={this.handleResponse}
					 handleClose={this.handleClose}
				 />
    		</div>
    	);
    }
}

export default ProjectsPage;




// WEBPACK FOOTER //
// ./src/components/pages/projects/ProjectsPage.js